import { DateTime } from "luxon";
import { CardStatus } from "@/api/generated/graphql";

export enum CardProvider {
  VISA = "visa",
  MASTERCARD = "mastercard",
}

export type Card = {
  id: string;
  token: string;
  type: string;
  number: string;
  holder: string;
  balance?: number;
  expiryDate: DateTime;
  provider: CardProvider;
  status: CardStatus;
};
